<template>
  <AssetTypeVideo />
  <div
    class="container h-100 d-flex align-items-unset justify-content-center z-2"
  >
    <div class="row mobile align-content-unset g-0">
      <TypeTopNav :heading="this.assetType" />

      <div class="col-12 d-flex align-items-unset justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <template
              v-for="(collection, key) in collections"
              :key="collection.guid"
            >
              <router-link
                :to="{
                  name: 'VideoView',
                  params: {
                    collectionId: collection.videoLibraryId,
                    guid: collection.guid,
                  },
                }"
                :class="[
                  key === 0
                    ? 'border-top-right-radius'
                    : key === collections.length - 1
                    ? 'border-bottom-left-radius'
                    : '',
                  'btn-theme-menu',
                  'mb-2',
                ]"
              >
                <span class="video-label">{{
                  collection.title.replace('.mp4', '')
                }}</span>
              </router-link>
            </template>

            <template v-for="(asset, key) in assetTypes" :key="asset.Guid">
              <!-- Video links -->

              <!-- Panorama links -->
              <router-link
                v-if="this.assetType === '360-Tours'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: asset.LinkName,
                    order: 0,
                  },
                }"
                :class="[
                  key === 0
                    ? 'border-top-right-radius'
                    : key === assetTypes.length - 1
                    ? 'border-bottom-left-radius'
                    : '',
                  'btn-theme-menu',
                  'mb-2',
                ]"
              >
                <span>{{ asset.ObjectName }}</span>
              </router-link>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetTypeVideo from '@/components/AssetTypeVideo.vue'
import TypeTopNav from '@/components/TypeTopNav.vue'
import TypeBotNav from '@/components/TypeBotNav.vue'
import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'
import sortArray from 'sort-array'

export default {
  name: 'AssetType',
  props: {
    assetType: String,
  },
  components: {
    AssetTypeVideo,
    TypeTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      collections: [],
      componentName: 'AssetView',
      folderStructure: encodeURIComponent(
        this.theme.devFolder + '/assets/' + this.assetType + '/'
      ),
      assetOrder: null,
    }
  },
  created() {
    this.assetOrder = this.theme.orderAssetsMenu
    if (this.assetType !== 'Cinematics') {
      BunnyNetService.getFolders(this.folderStructure)
        .then((response) => {
          // Remap array
          const menuItems = response.data.map((item) => {
            return {
              Guid: item.Guid,
              ObjectName: unslugify(item.ObjectName),
              LinkName: item.ObjectName,
              ComponentName: this.componentName,
              Path: item.Path,
              IsDirectory: item.IsDirectory,
              StorageZoneName: item.StorageZoneName,
            }
          })

          // Sort array
          const customMenu = sortArray(menuItems, {
            by: ['LinkName'],
            order: 'LinkName',
            customOrders: {
              LinkName: this.assetOrder,
            },
          })
          this.assetTypes = customMenu
        })
        .catch((error) => {
          console.log(error)
        })
    }
    if (this.assetType === 'Cinematics') {
      BunnyNetService.getVideos(
        this.theme.videoLibraryId,
        'd1e3d165-8cee-4bbe-ba0c-9bbdb141649d'
      )
        .then((response) => {
          const responseData = response.data.items
          const orderCollection = sortArray(responseData, {
            by: ['title'],
            order: 'title',
            customOrders: {
              title: this.assetOrder.map((item) => item + '.mp4'),
            },
          })
          this.collections = orderCollection
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  setup() {
    // load global config
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
